import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { SupportedTickersResponse } from '../entities';
import { StockReportsEnvironment } from '../environment';

export class StockReportsTickersRestful extends RestfulClient {
  constructor(sessionManager: Session) {
    super(sessionManager.getEnvironment(StockReportsEnvironment).internalURL, sessionManager);
  }

  getSupportedTickers = (): SafePromise<SupportedTickersResponse> => {
    const url = this.URL('https://api.benzinga.com/api/v1/report/supported-tickers-v2');
    return this.debouncedGet(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
